<template>
  <div class="aside-box btn-lines">
    <div class="aside-btn" @click="$emit('zoom')">
      <el-tooltip effect="dark" :content="isZoomIn ? $t('tj.zs.xt') : $t('tj.zs.dt')" placement="top">
        <img v-if="!isZoomIn" src="@/assets/zs_imgs/live2d-zoom-in-icon.png" alt="" />
        <img v-else src="@/assets/zs_imgs/live2d-zoom-out-icon.png" alt="" />
      </el-tooltip>
    </div>
    <div class="aside-btn" @click="$emit('lh')">
      <el-tooltip :content="$t('tj.zs.lh')" placement="top">
        <img src="@/assets/zs_imgs/live2d-image-icon.png" alt="" />
      </el-tooltip>
    </div>
    <div class="aside-btn" @click="$emit('downloadLh')">
      <el-tooltip :content="$t('tj.zs.lhxz')" placement="top">
        <img src="@/assets/zs_imgs/live2d-download-icon.png" alt="" />
      </el-tooltip>
    </div>
  </div>
</template>
<script>
export default {
  name: "Live2dBtnLines",
  props: {
    isZoomIn: { type: Boolean, default: false }
  }
};
</script>
<style lang="less" scoped>
.aside-box {
  z-index: 100;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  // gap: 9px;s
  &.btn-lines {
    display: flex;
    flex-direction: column;
    top: 750px;
    right: 890px;
    .aside-btn {
      margin-bottom: 23px;
    }
  }
  .aside-btn {
    position: relative;
    z-index: 11;
    width: 25px;
    height: 25px;
    cursor: pointer;

    .arrow-icon {
      position: absolute;
      left: -10px;
      top: 11px;
      width: 12px;
      height: 12px;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center top;
    }
  }
  .btn-box {
    position: absolute;
    visibility: hidden;
    opacity: 0;
    right: -10px;
    top: -8px;
    display: flex;
    gap: 24px;
    align-items: center;
    padding-left: 26px;
    width: 100px;
    height: 50px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 28px 0px 0px 28px;
    transition: all 0.3s;

    &.active {
      width: 216px;
      visibility: visible;
      opacity: 1;
      .btn {
        opacity: 1;
        visibility: visible;
      }
    }
    .btn {
      opacity: 0;
      width: 24px;
      height: 24px;
      transition: opacity 0.3s;
      transition-delay: 0.3s;
      visibility: hidden;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
